const Validations = {
    form: {
        required: 'O campo {LABEL} é obrigatório!',
        thisCharLength: 'O campo {LABEL} deve conter {VALUE} caracteres!',
        maxCharLength: 'O campo {LABEL} deve conter no máximo {VALUE} caracteres!',
        minCharLength: 'O campo {LABEL} deve conter no mínimo {VALUE} caracteres!',
        maxAndMinCharLength:
            'O campo {LABEL} deve conter no mínimo {MIN} e no máximo {MAX} caracteres!',
        format: 'O campo {LABEL} está em um formato inválido!',
        fileMaxLength: 'O campo {LABEL} deve conter um arquivo de no máximo {VALUE}MB!',
        minArrayLength: 'Favor selecionar ao menos um valor para os {LABEL}!',
        minDateNow: 'A data informada deve ser maior ou igual ao dia de hoje.',
        optionalFields: 'Informe o campo {CAMPO1} ou {CAMPO2} para continuar!',
    },
};

export default Validations;
